module.exports = __webpack_public_path__ + "img/2recr_province.98e4b5da.png";